/**
 * @description
 * Este arquivo define as rotas (paths) do frontend da aplicação (vulgo os diferentes caminhos da URL).
 *
 * As rotas descritas no arquivo `src/utils/axios.ts` são referentes aos endpoints do backend,
 * que serão utilizados para a integração do front-end ao back-end, via repositories.
 */

const ROOTS = {
  AUTH: '/auth',
  WEBAPP: '/webapp',
  RULES: '/rules',
};

export const paths = {
  root: '/',
  auth: {
    root: ROOTS.AUTH,
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    refresh: `${ROOTS.AUTH}/refresh`,
  },

  error: {
    notFound: '/404',
    forbidden: '/403',
    serverError: '/500',
  },

  webapp: {
    root: ROOTS.WEBAPP,

    // HOME
    home: {
      root: `${ROOTS.WEBAPP}/home`,
    },
    // BENEFITS
    benefits: {
      root: `${ROOTS.WEBAPP}/benefits`,
      readQrCode: `${ROOTS.WEBAPP}/benefits/read-qr-code`,
      userRedeems: `${ROOTS.WEBAPP}/benefits/user-redeems/:userCode`,
    },
    // CAMPAIGN REWARDS
    campaigns: {
      root: `${ROOTS.WEBAPP}/campaigns`,
      readQrCode: `${ROOTS.WEBAPP}/campaigns/read-qr-code`,
      userRewards: `${ROOTS.WEBAPP}/campaigns/user-rewards/:userCode`,
    },
    // POINTS
    points: {
      root: `${ROOTS.WEBAPP}/points`,
      readQrCode: `${ROOTS.WEBAPP}/points/read-qr-code`,
      add: `${ROOTS.WEBAPP}/points/add/:userCode`,
    },
    // ROULETTE
    roulette: {
      root: `${ROOTS.WEBAPP}/roulette`,
      readQrCode: `${ROOTS.WEBAPP}/roulette/read-qr-code`,
      spin: `${ROOTS.WEBAPP}/roulette/spin/:userCode`,
    },
  },
};
